import React from 'react'
import { makeStyles, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import AddSeasonForm from '../form/forms/AddSeasonForm/AddSeasonForm'
import ContainerPadding from '../containerPadding/containerPadding'
import addSeasonModalStyles from './addSeasonModal.styles'
import DialogWithCloseIcon from '../DialogWithCloseIcon/DialogWithCloseIcon'
import useGetLocalStorage from '../../hooks/useGetLocalStorage'
import localStorageIds from '../../utils/constants/localStorageIds'

const AddSeasonModal = (props) => {
  const { isOpen, onClose, seasonData, competitionId } = props
  const isEditMode = Boolean(seasonData)
  const useStyles = makeStyles(addSeasonModalStyles)
  const classes = useStyles()
  const localStorageValue = useGetLocalStorage()
  const { [localStorageIds.SELECTED_ORG]: selectedOrg } = localStorageValue || {}

  return (
    <DialogWithCloseIcon
      open={isOpen}
      dialogWidth='650px'
      onClose={onClose}
      dialogTitle={
        <Typography component='div' variant='h6' className={classes.title}>
          {isEditMode ? 'Edit Season' : 'Add Season'}
        </Typography>
      }
    >
      <ContainerPadding paddingValue='1%'>
        <AddSeasonForm onClose={onClose} orgId={selectedOrg?.id} seasonData={seasonData} competitionId={competitionId} />
      </ContainerPadding>
    </DialogWithCloseIcon>
  )
}

AddSeasonModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  seasonData: PropTypes.object,
  competitionId: PropTypes.string,
}

AddSeasonModal.defaultProps = {
  isOpen: false,
}

export default AddSeasonModal